import module from 'app/module.js'
import template from './template.html'

class AppExcelImportarInputComponent {
  constructor () {
    this.data = ''
    this.onChange = null
    this.ayuda = false
    this.error = null
    this.incluirEncabezados = true
  }

  aceptar () {
    if (!this.data) return

    this.error = null

    let headersCount = 0
    let rows = this.data.split('\n')
      .map((row) => row.split('\t'))
      .map((cells) => {
        headersCount = Math.max(headersCount, cells.length)

        return cells.map((value) => value.trim().replace(/\s\s+/g, ' '))
      })

    let headers = (this.incluirEncabezados ? rows.splice(0, 1)[0] : new Array(headersCount))

    if (rows.length) {
      this.onChange({$event: {data: {rows, headers}}})
    } else {
      this.error = 'No hay suficientes lineas para procesar.'
    }
  }

  borrar () {
    this.data = ''
  }
}

module.component('appExcelImportarInput', {
  controller: AppExcelImportarInputComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/excel/importar/input/component.js